import { useT } from '@/i18n/LanguageContext';

export function EmptyState({ title, hint }: { title: string; hint?: string }): JSX.Element {
  return (
    <div className="empty-state">
      <div>{title}</div>
      {hint && <div style={{ fontSize: 12, marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

export function LoadingState({ label }: { label?: string }): JSX.Element {
  const t = useT();
  return (
    <div className="empty-state" role="status" aria-live="polite">
      {label ?? t('common.loading')}
    </div>
  );
}

/**
 * COMMERCIAL LAYER epic (ADR-075 Part C) - the epic's explicit "you tried
 * to access something not yours" state. The backend never distinguishes
 * "does not exist" from "belongs to another seller" (COMMON.NOT_FOUND for
 * both, ADR-075 §Part B.4 - a manipulated id must never confirm existence),
 * so the UI can't either: this renders identically for a genuinely deleted
 * record and someone else's id typed into the URL. Never a crash, never a
 * leak of the other seller's data.
 */
export function NotFoundState({ hint }: { hint?: string }): JSX.Element {
  const t = useT();
  return (
    <div className="empty-state" role="alert">
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('common.notFound')}</div>
      <div>{hint ?? t('common.notFoundHint')}</div>
    </div>
  );
}
